import { render, staticRenderFns } from "./OsStats.vue?vue&type=template&id=2fdc744c&"
import script from "./OsStats.vue?vue&type=script&lang=js&"
export * from "./OsStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports